import { suggestions, allSuggestions, selectedSuggestion, loading, error, pagination, filters } from './state'
import { fetchSuggestions, fetchSuggestionById, applyFiltersAndPagination } from './methods/fetch-suggestions'
import { createSuggestion } from './methods/handle-create'
import { updateSuggestion } from './methods/handle-update'
import { deleteSuggestion } from './methods/handle-delete'

/**
 * Önerileri yönetmek için composable
 * @returns {Object} Öneri yönetimi için gerekli state ve metodlar
 */
export const useSuggestionsManagement = () => {
  /**
   * Öneriyi seç
   * @param {Object|null} suggestion - Seçilecek öneri
   */
  const selectSuggestion = (suggestion) => {
    selectedSuggestion.value = suggestion
  }
  
  /**
   * Öneri filtrelerini güncelle ve önerileri filtrele
   * @param {Object} newFilters - Yeni filtreler
   */
  const setFilters = async (newFilters) => {
    // Filtreleri güncelle
    Object.assign(filters, newFilters)
    
    // Verileri ilk kez getirme veya yenileme durumu
    if (allSuggestions.value.length === 0) {
      // API'den önerileri getir
      await fetchSuggestions(filters)
    } else {
      // Sadece mevcut verilere filtreleme ve sayfalama uygula
      applyFiltersAndPagination(filters)
    }
  }
  
  /**
   * Hata mesajını temizle
   */
  const clearError = () => {
    error.value = null
  }
  
  /**
   * Sayfa değişikliğini yönet
   * @param {Number} page - Yeni sayfa numarası
   */
  const handlePageChange = (page) => {
    // Sayfa numarasını güncelle ve yerel filtreleme uygula
    applyFiltersAndPagination({ ...filters, page })
  }
  
  /**
   * İçerik tipine göre filtrele
   * @param {String} contentType - İçerik tipi
   */
  const filterByContentType = (contentType) => {
    applyFiltersAndPagination({ ...filters, contentType, page: 1 })
  }
  
  /**
   * İçerik kategorisine göre filtrele
   * @param {String} contentCategory - İçerik kategorisi
   */
  const filterByContentCategory = (contentCategory) => {
    applyFiltersAndPagination({ ...filters, contentCategory, page: 1 })
  }
  
  return {
    // State
    suggestions,
    allSuggestions,
    selectedSuggestion,
    loading,
    error,
    pagination,
    filters,
    
    // Metodlar
    fetchSuggestions,
    fetchSuggestionById,
    createSuggestion,
    updateSuggestion,
    deleteSuggestion,
    selectSuggestion,
    setFilters,
    clearError,
    handlePageChange,
    filterByContentType,
    filterByContentCategory,
    applyFiltersAndPagination
  }
}
